module.exports = __webpack_public_path__ + "static/media/doritos.fb18ad14.jpeg";